export default __webpack_public_path__ + "static/media/pr{2}b_2_lowdef.cd5bdb04.png";